import { render, staticRenderFns } from "./FinanceTagCreate.vue?vue&type=template&id=d33b45a0"
import script from "./FinanceTagCreate.vue?vue&type=script&lang=js"
export * from "./FinanceTagCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports